<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Branch</label>
            <div class="col-lg-6">
              <select
                name="tahun"
                id="branch"
                class="custom-select"
                v-model="branch"
              >
                <template v-for="bran in branchs">
                  <option v-bind:value="bran.id.toString()" :key="bran.id">{{
                    bran.name
                  }}</option>
                </template>
              </select>
              <!-- <b-form-radio-group
                v-model="radioPresence"
                :options="options"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group> -->
            </div>
          </div>
          <div class="form-group row">
            <button class="btn btn-primary" @click="submit">Submit</button
            >&nbsp;
          </div>
          <br />
          <div>
            <template v-if="show && !deleteshow">
              <div class="from-group row">
                <label for="" class="col-12 col-form-label font-weight-bold"
                  >Departement</label
                >
                <div class="col-sm-6">
                  <Select2
                    v-model="dept"
                    :settings="setting"
                    :options="list_dept"
                  />
                </div>
              </div>
              <div class="from-group row">
                <label for="" class="col-12 col-form-label font-weight-bold"
                  >Religion</label
                >
                <div class="col-sm-6">
                  <select name="religion" v-model="religion">
                    <option value="0" selected>All</option>
                    <option value="1">Islam</option>
                    <option value="2">Protestan</option>
                    <option value="3">Katolik</option>
                    <option value="4">Budha</option>
                    <option value="5">Hindu</option>
                    <option value="6">Konghucu</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="from-group row">
                <div class="col-md-6">
                  <b-form-group label="Users:">
                    <label for="select" v-if="list.length > 0">
                      <input
                        type="checkbox"
                        @click="selectAll"
                        v-model="allSelected"
                      />
                      Select All
                    </label>
                    <div class="show-data">
                      <b-form-checkbox-group
                        id="checkbox-group"
                        v-model="selected"
                        name="selectedUsers"
                      >
                        <b-form-checkbox
                          v-for="(user, index) in list"
                          :value="user.id"
                          v-model="userIds"
                          @click="select"
                          :key="user.id"
                          switch
                          class="block-important"
                        >
                          {{ user.text }}
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </div>
                    <span v-if="list.length == 0"
                      >No employees in this category
                    </span>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <transition-group name="fade" mode="out-in">
                    <template v-if="showDate">
                      <div class="from-group row" key="onlyDate">
                        <div class="col-6">
                          <label>Jam Masuk</label>
                          <date-picker
                            v-model="time_start"
                            format="HH:mm"
                            value-type="format"
                            type="time"
                            placeholder="HH:mm"
                          ></date-picker>
                        </div>
                        <div class="col-6">
                          <label>Jam Pulang</label>
                          <date-picker
                            v-model="time_end"
                            format="HH:mm"
                            value-type="format"
                            type="time"
                            placeholder="HH:mm"
                          ></date-picker>
                        </div>
                        <button
                          class="btn btn-primary btn-lanjut"
                          @click="showDate = false"
                        >
                          Lanjut
                        </button>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="form-group row"
                        style="margin-top: 1rem;"
                        key="onlyhour"
                      >
                        <div class="col-md-6">
                          <label for="">Start Date</label>
                          <date-picker
                            v-model="start_date"
                            type="date"
                            lang="en"
                            format="DD-MM-YYYY"
                          ></date-picker>
                        </div>
                        <div class="col-md-6">
                          <label>End Date</label>
                          <date-picker
                            v-model="end_date"
                            type="date"
                            lang="en"
                            format="DD-MM-YYYY"
                          ></date-picker>
                        </div>
                        <div class="col-md-12" style="padding-top: 7px">
                          <button
                            class="btn btn-primary"
                            @click="showDate = true"
                          >
                            Back
                          </button>
                          <button
                            class="btn btn-primary"
                            @click="save"
                            style="margin-left: 10px"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </template>
                  </transition-group>
                </div>
              </div>
            </template>
            <template v-else-if="show && deleteshow">
              <h3>Dalam Tahap Pembuatan</h3>
              <!-- <delete-presence /> -->
            </template>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { getService, postService } from "../../../services";
import DeletePresence from "./DeletePresence";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    DatePicker,
    DeletePresence
  },
  data() {
    return {
      branch: "",
      deleteshow: false,
      branchs: [],
      checkBranch: "",
      list: [],
      selected: [],
      listAll: [],
      allSelected: false,
      userIds: [],
      show: false,
      dept: "",
      setting: {
        multiple: true
      },
      list_dept: [],
      religion: "0",
      start_date: "",
      end_date: "",
      showDate: true,
      time_start: "08:30",
      time_end: "17:00",
      boxTwo: "",
      radioPresence: "1",
      options: [
        { item: "1", name: "Add Presence" },
        { item: "2", name: "Delete Presence" }
      ]
    };
  },
  created: function() {
    this.getBranch();
    var that = this;
    if (this.$store.getters.branchInVendor) {
      this.branch = this.$store.getters.branchInVendor;
    } else {
      this.checkBranch = setInterval(() => {
        that.branch = that.$store.getters.branch;
        if (that.branch) {
          clearInterval(that.checkBranch);
        }
      }, 1000);
    }
  },
  watch: {
    dept(val) {
      let employee = this.checkDepartement(val, this.listAll);
      this.list = this.checkReligion(this.religion, employee);
      // let employee;
      // let employeeAll = [];
      // let religion = this.religion;
      // for (let i = 0; i < val.length; i++) {
      //   employee = this.listAll.filter(function(el) {
      //     if (religion == 0) {
      //       return el.dept == val[i];
      //     } else {
      //       return el.dept == val[i] && el.religion == religion;
      //     }
      //   });
      //   if (employeeAll.length > 0) {
      //     employeeAll.push.apply(employeeAll, employee);
      //   } else {
      //     employeeAll = employee;
      //   }
      // }
      // this.allSelected = false;
      // this.list = employeeAll;
    },
    religion(val) {
      let employee = this.checkDepartement(this.dept, this.listAll);
      this.list = this.checkReligion(val, employee);
      // this.list = this.checkReligion(val, this.listAll);
      // let employee;
      // this.allSelected = false;
      // if (val != 0) {
      //   employee = this.listAll.filter(function(el) {
      //     return el.religion == val;
      //   });
      //   this.list = employee;
      // } else {
      //   this.list = this.listAll;
      // }
    }
  },
  methods: {
    checkDepartement(dept, list) {
      let employee;
      let employeeAll = [];
      let religion = this.religion;
      for (let i = 0; i < dept.length; i++) {
        employee = list.filter(function(el) {
          if (religion == 0) {
            return el.dept == dept[i];
          } else {
            return el.dept == dept[i] && el.religion == religion;
          }
        });
        if (employeeAll.length > 0) {
          employeeAll.push.apply(employeeAll, employee);
        } else {
          employeeAll = employee;
        }
      }
      this.allSelected = false;
      if (dept.length == 0) {
        return list;
      } else {
        return employeeAll;
      }
    },
    checkReligion(religion, list) {
      let employee;
      this.allSelected = false;
      if (religion != 0) {
        employee = list.filter(function(el) {
          return el.religion == religion;
        });
        return employee;
      } else {
        return list;
      }
    },
    async getBranch() {
      try {
        await getService.list_branch().then(data => {
          this.branchs = data;
        });
      } catch (error) {
        // bila data tidak terpanggil
      }
    },

    async getListDept() {
      try {
        await getService.list_dev().then(data => {
          let ary = [];
          for (let i = 0; i < data.length; i++) {
            const obj = {
              id: data[i].DeptId,
              text: data[i].DeptDetails
            };
            ary.push(obj);
          }
          this.list_dept = ary;
        });
      } catch (error) {
        // error
      }
    },
    submit() {
      //   console.log(this.branch);
      if (this.radioPresence == 1) {
        this.deleteshow = false;
        getService.list_employee_branch(this.branch).then(employee => {
          this.show = true;
          var ary = [];
          this.getListDept();
          //   this.employee = employee
          for (let i = 0; i < employee.length; i++) {
            const obj = {
              id: employee[i].EmpId,
              text: employee[i].EmpFName + " " + employee[i].EmpLName,
              dept: employee[i].DeptId,
              religion: employee[i].EmpReligion
            };
            ary.push(obj);
          }
          ary.sort((a, b) => {
            if (a.text < b.text) {
              return -1;
            }
            if (a.text > b.text) {
              return 1;
            }
            return 0;
          });
          this.list = ary;
          this.listAll = ary;
        });
      } else {
        this.show = true;
        this.deleteshow = true;
      }
    },
    setAll(list) {
      var list_array = [];
      if (list.length > 0) {
        list.forEach(element => {
          list_array.push(element.text);
        });
        return list_array;
      }
      return false;
    },
    select() {
      this.allSelected = false;
    },
    save() {
      // console.log(this.start_date, this.end_date, this.selected);
      if (this.start_date && this.end_date && this.selected.length > 0) {
        postService
          .postPresence(
            this.start_date,
            this.end_date,
            this.selected,
            this.time_start,
            this.time_end,
            this.branch
          )
          .then(data => {
            this.showModal("Success", data.title);
          })
          .catch(error => {
            this.showModal("Success", error.title);
          });
      } else {
        // alert("Tolong lengkapi");
        this.showModal("Gagal", "Mohon Isi Data");
      }
    },
    selectAll() {
      this.userIds = [];
      if (!this.allSelected) {
        for (let user in this.list) {
          this.userIds.push(this.list[user].id.toString());
        }
      }
    },
    showModal(title, text) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(text, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          this.boxTwo = value;
        })
        .catch(err => {
          // An error occurred
        });
    }
  }
};
</script>
<style scoped>
.block-important {
  display: block !important;
}
.show-data {
  padding-left: 5px;
}

.btn-lanjut {
  margin-left: 14px;
  margin-top: 1em;
}
</style>
